<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span class="inputBoxUnit warning" slot="problemConditionTip">
        {{
        problemConditionTip ? ('说明：' + problemConditionTip) : ''
        }}
      </span>
      <span class="inputBoxUnit warning" slot="problemTypeTip">
        {{
        problemTypeTip ? ('说明：' + problemTypeTip) : ''
        }}
      </span>
      <span class="inputBoxUnit warning" slot="problemPriceTip">填写金额不能小于零</span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  orderTimeDriverList,
  orderDetail,
} from 'api/operate';
import {
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      problemConditionTip: '',
      problemTypeTip: '',
      orderInfo: {},
      orderCarInfo: {},
      baseForm: {
        problemConditionOptions: [], // 结算方
        problemTypeOptions: [], // 异常类型
        carOwnerIdOptions: [], // 责任司机
        form: [
          {
            label: '订单编号',
            value: 'orderId',
            type: 'input',
            disabled: true,
          },
          {
            label: '订单状态',
            value: 'orderStateName',
            type: 'input',
            disabled: true,
          },
          {
            label: '订单来源',
            value: 'orderTypeName',
            type: 'input',
            disabled: true,
          },
          {
            label: '结算方',
            value: 'problemCondition',
            type: 'select',
            onChange: () => {
              this.handleProblemCondition();
            },
          },
          {
            label: '异常类型',
            value: 'problemType',
            type: 'select',
            onChange: () => {
              this.handleProblemType();
            },
          },
          {
            label: '异常金额',
            value: 'problemPrice',
            type: 'input',
            unit: '元',
            onInput: () => {
              const problemPrice = this.$refs.baseForm.getVal('problemPrice');
              this.$refs.baseForm.setVal('problemPrice', problemPrice.replace(/\-/g, ''));
            },
          },
          {
            label: '异常描述',
            value: 'problemDesc',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '责任司机',
            value: 'carOwnerId',
            type: 'select',
            hide: false,
          },
        ],
        rules: {
          lineNodeIndex: [ // 时效路段
            { required: true, message: '请选择时效路段', trigger: 'blur' },
          ],
          orderStartDate: [ // 离台时间
            { required: true, message: '请选择离台时间', trigger: 'blur' },
          ],
          orderArriveDate: [ // 到达时间
            { required: true, message: '请选择到达时间', trigger: 'blur' },
          ],
          arriveTime: [ // 运输时间
            { required: true, message: '请输入运输时间', trigger: 'blur' },
          ],
          finePrice: [ // 罚款金额
            { required: true, message: '请输入罚款金额', trigger: 'blur' },
          ],
          remark: [ // 时效描述
            { required: true, message: '请输入时效描述', trigger: 'blur' },
          ],
          problemPrice: [
            { required: false, message: '请输入异常金额', trigger: 'blur' },
            { validator: this.checkPrice, trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    checkPrice (rule, value, call) {
      if (value < 0) {
        call('填写金额不能小于零');
      } else {
        call();
      }
    },
    // 结算方
    async handleProblemCondition () {
      const problemCondition = this.$refs.baseForm.getVal('problemCondition');
      for (let i = 0; i < this.baseForm.problemConditionOptions.length; i++) {
        if (this.baseForm.problemConditionOptions[i].value === problemCondition) {
          this.problemConditionTip = this.baseForm.problemConditionOptions[i].desc;
          const codeType = this.baseForm.problemConditionOptions[i].codeType;
          // 异常类型
          const enumsList = await getEnumList({
            codeType,
          });
          this.baseForm.problemTypeOptions = enumsList[0];
          break;
        }
      }
      this.handleProblemType();
      this.handleDisplayCarOwnerId();
    },
    // 异常类型
    async handleProblemType () {
      const problemType = this.$refs.baseForm.getVal('problemType');
      for (let i = 0; i < this.baseForm.problemTypeOptions.length; i++) {
        if (this.baseForm.problemTypeOptions[i].value === problemType) {
          this.problemTypeTip = this.baseForm.problemTypeOptions[i].codeDesc;
          break;
        }
      }
    },
    // 责任司机
    handleDisplayCarOwnerId () {
      const problemCondition = this.$refs.baseForm.getVal('problemCondition');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: problemCondition === 2,
        names: ['carOwnerId'],
      });
    },
    async getList () {
      if (!this.$route.query.orderId) {
        return;
      }
      // 订单详情
      const orderRes = await orderDetail({
        orderId: this.$route.query.orderId,
      });
      this.orderInfo = orderRes.orderInfo;
      this.orderCarInfo = orderRes.orderScheduler;
      // 责任方选择列表
      this.baseForm.problemConditionOptions = [
        {
          label: `司机（${orderRes.orderScheduler.plateNumber}）`,
          value: 1,
          desc: '成本异常，与承运方结算异常费用',
          codeType: 'RECRIVE_ORDER_PROBLEM_TYPE@COST',
        },
        {
          label: `${orderRes.orderGoods.companyName}`,
          value: 2,
          desc: '收入异常，与发货方结算异常费用',
          codeType: 'RECRIVE_ORDER_PROBLEM_TYPE@INCOME',
          disabled: true,
        },
      ];
      // 责任司机列表
      const driverRes = await orderTimeDriverList({
        orderId: this.$route.query.orderId,
      });
      this.baseForm.carOwnerIdOptions = driverRes.items.map((item) => ({
        label: item.userName,
        value: item.userId,
        ...item,
      }));
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        for (let i = 0; i < this.baseForm.problemConditionOptions.length; i++) {
          if (this.baseForm.problemConditionOptions[i].value === formData.problemCondition) {
            formData.responsiblePartyName = this.baseForm.problemConditionOptions[i].label;
            break;
          }
        }
        formData.orderId = this.orderInfo.orderId;
        formData.carOwnerName = this.orderCarInfo.onDutyDriverName;
        formData.carOwnerPhone = this.orderCarInfo.onDutyDriverPhone;
      }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData();
      if (res.problemPrice) {
        res.problemPrice = res.problemPrice * 100;
      }
      res.problemReason = res.problemDesc;
      return res;
    },
    async init (data = {}) {
      data = {
        ...data,
        ...this.orderInfo,
      };
      if (data.problemPrice) {
        data.problemPrice = `${data.problemPrice / 100}`.replace(/\-/g, '');
      }
      data.problemDesc = data.problemReason;
      // 结算方
      if (!data.problemCondition) {
        data.problemCondition = this.baseForm.problemConditionOptions[0].value;
      }
      // 异常类型
      if (!data.problemType) {
        data.problemType = '';
      }
      // 责任司机
      if (!data.carOwnerId) {
        data.carOwnerId = this.baseForm.carOwnerIdOptions[0].value;
      }
      this.$refs.baseForm.setVal(data);
      this.handleProblemCondition();
    },
  },
};
</script>

<style scoped lang="scss">
.inputBoxUnit {
  margin-left: 16px;
}
</style>
